import { cmsTranslations } from '@riptik/cms-backoffice-module'
import { fnbposTranslations } from '@riptik/fnbpos-backoffice-module'
import { courtTranslations } from '@riptik/court-backoffice-module'
import common from './common.json'
import menu from './menu.json'
import events from './pages/events.json'
import customers from './pages/customers.json'
import items from './pages/items.json'
import organizationSettings from './pages/organizationSettings.json'
import organizationSettingsDetails from './pages/organizationSettingsDetails.json'
import eventSettings from './pages/eventSettings.json'
import eventSettingsDetails from './pages/eventSettingsDetails.json'
import categories from './pages/categories.json'
import tags from './pages/tags.json'
import quotas from './pages/quotas.json'
import seatingPlans from './pages/seatingPlans.json'
import subevents from './pages/subevents.json'
import vouchers from './pages/vouchers.json'
import promotions from './pages/promotions.json'
import giftcards from './pages/giftcards.json'
import checkinlists from './pages/checkinlists.json'
import checkindevices from './pages/checkindevices.json'
import suppliers from './pages/suppliers.json'
import questions from './pages/questions.json'
import products from './pages/products.json'
import thirdparty from './pages/thirdparty.json'
import settlements from './pages/settlements.json'
import apiCallLogs from './pages/apiCallLogs.json'
import unitLedger from './pages/unitLedger.json'
import payments from './pages/payments.json'
import dashboard from './pages/dashboard.json'
import orders from './pages/orders.json'
import orderDetails from './pages/orderDetails.json'
import pageEditor from './pages/pageEditor.json'
import admin from './pages/admin.json'
import organizationUsers from './pages/organizationUsers.json'

// CMS translations from @riptik/cms-backoffice-module
const cmsVi = cmsTranslations.vi
// F&B/POS translations from @riptik/fnbpos-backoffice-module — xem giải thích ở resources/en/index.ts
const fnbposVi = fnbposTranslations.vi
// Court translations from @riptik/court-backoffice-module — xem giải thích ở resources/en/index.ts
const courtVi = courtTranslations.vi

export default {
  ...common,
  ...menu,
  // Merge CMS module's common translations (module's common as fallback)
  ...cmsVi.common,
  common: {
    ...cmsVi.common,
    ...fnbposVi.common,
    ...courtVi.common,
    ...common.common,
  },
  fnbpos: fnbposVi.fnbpos,
  court: courtVi.court,
  pages: {
    ...cmsVi.pages,
    ...events.pages,
    ...customers.pages,
    ...items.pages,
    ...organizationSettings.pages,
    ...organizationSettingsDetails.pages,
    ...eventSettings.pages,
    ...eventSettingsDetails.pages,
    ...categories.pages,
    ...tags.pages,
    ...quotas.pages,
    ...seatingPlans.pages,
    ...subevents.pages,
    ...vouchers.pages,
    ...promotions.pages,
    ...giftcards.pages,
    ...checkinlists.pages,
    ...checkindevices.pages,
    ...suppliers.pages,
    ...questions.pages,
    ...products.pages,
    ...thirdparty.pages,
    ...settlements.pages,
    ...apiCallLogs.pages,
    ...unitLedger.pages,
    ...payments.pages,
    ...dashboard.pages,
    ...orders.pages,
    ...orderDetails.pages,
    ...pageEditor.pages,
    ...admin.pages,
    ...organizationUsers.pages,
    // Deep-merge organizationSettings so CMS module additions don't overwrite local tabs/fields
    organizationSettings: {
      ...cmsVi.pages?.organizationSettings,
      ...organizationSettings.pages.organizationSettings,
    },
  },
}
